module.exports = {
    props: ['user']
};
